import { isArray } from "src/app/_helper/util.helper";


export class SearchInputConfigModel {

  public agentLabel: string = 'Agent';
  public agentDisplay: { key: string, label?: string }[] = [];
  
  public officeLabel: string = 'Office';
  public officeDisplay: { key: string, label?: string }[] = [];

  constructor(model?: Partial<SearchInputConfigModel>) {
    if (model)
      for (let key in this as SearchInputConfigModel)
        if (model[key]) {
          if (isArray(model[key]))
            this[key] = [ ...model[key] ];
          else
            this[key] = model[key];
        }
  }
}
